import { render } from "./LoginPage.vue?vue&type=template&id=725a69f7&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__